<template>
    <div 
        class="o-w-items-header w-items-header"
        :class="{ 'w-items-header--white': !color }"
        :style="{ 'background-color': color }"
    >
        <slot name="left" />
        <div class="w-items-header__wrapper">
            <h3 class="w-items-header__title">
                {{ title }}
            </h3>
            <h4
                v-if="subtitle"
                class="w-items-header__subtitle"
            >
                {{ subtitle }}
            </h4>
        </div>
        <slot name="right" />
    </div>
</template>

<script>
export default {
    name: 'OWItemsHeader',
    props: {
        title: {
            type: String,
            default: ''
        },
        subtitle: {
            type: String,
            default: ''
        },
        color: {
            type: String,
            default: ''
        }
    }
}
</script>

<style lang="scss">
@import "o-w-items-header";
</style>